import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

import { Pagination } from '../../types/pagination';
import { SupportService } from '../../types/supportService';

type CompanySupportServiceIndexRequest = {
  keyword?: string;
  support_service_category_id?: number;
  support_service_tag_id?: number;
  status?: string;
  page?: number;
  per_page?: number;
  sort?: string;
  direction?: string;
};

type CompanySupportServiceIndexResponse = {
  data: SupportService[];
  pagination: Pagination;
};

type CompanySupportServiceShowResponse = SupportService;

export const companySupportServiceApiClient = {
  index: async (
    params: CompanySupportServiceIndexRequest = {},
  ): Promise<ApiResult<CompanySupportServiceIndexResponse>> => {
    return await axiosClient.get('/company/support-services', { params });
  },
  show: async (id: number): Promise<ApiResult<CompanySupportServiceShowResponse>> => {
    return await axiosClient.get(`/company/support-services/${id}`);
  },
};
